import type { ReactNode } from 'react'
import { motion } from 'motion/react'
import { Gift } from 'lucide-react'

interface EmptyStateProps {
  action?: ReactNode
}

export default function EmptyState({ action }: EmptyStateProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', damping: 20, stiffness: 260 }}
      className="flex flex-col items-center justify-center py-16 text-center"
    >
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-neutral-100">
        <Gift className="h-10 w-10 text-neutral-900" />
      </div>
      <h2 className="mt-6 text-2xl font-extrabold text-foreground">
        La tua wishlist è vuota
      </h2>
      <p className="mt-2 max-w-sm text-muted-foreground">
        Aggiungi il tuo primo desiderio: incolla un link e la foto arriva da sola.
      </p>
      {action && <div className="mt-8">{action}</div>}
    </motion.div>
  )
}
